import styled from "styled-components";

export const MarketplaceContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    flex: 4;
`

export const MarketplaceWrapper = styled.div`
    margin-top: 65px;
    padding: 1em;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`